import { useEffect, useState, useContext } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, formatDate, getInlineLoader, trimString } from '../Helpers';
import { AiOutlineUser, AiFillStar } from 'react-icons/ai';
import { IoPersonAddSharp } from 'react-icons/io5';
import { MdAttachFile } from 'react-icons/md';

export default function OneChatRoom(props) {
  const appContext = useContext(AppContext);
  
  const [ chatData, setChatData ] = useState(props.chatData);
  const [ messages, setMessages ] = useState(null);
  const [ topMessage, setTopMessage ] = useState("");

  const init = async () => {
    if(chatData) {
      setMessages(JSON.parse(chatData.messages));
    }
  }

  function getChatTitle(users) {
    if(users) {
      const currentUsername = appContext.userData.username;

      for (const _user of users) {
        if(_user.username != currentUsername) {
          return _user.username;
          break;
        }
      }
    }
    return "Friendly Chat";
  }

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'chatroom',
      extraItem: chatData.uid,
    })
  }

  useEffect(() => {
    init();
  }, [ chatData ]);

  useEffect(() => {
    setChatData(props.chatData);
  }, [ props.chatData ])

  useEffect(() => {
    if(messages) {
      if(messages.length > 0) {
        let _top = messages[messages.length - 1];
        let _text = "";

        if(_top.file) {
          _text += "[image] "
        }

        _text += _top.body;

        setTopMessage(_text);
      }
    }
  }, [ messages ])
  
  return (
    <div
      onClick={view}
      className='mSupportLoading'
      style={{
        width: "100%",
        padding: "10px",
        marginTop: "10px",
        marginBottom: "10px",
        cursor: "pointer",
        border: "2px solid var(--faintBlack)",
        borderRadius: "20px"
      }}
    >
      {
        (chatData) ?
        <div
          style={{
            width: "100%",
          }}
        >
          <h6 className='text-bluish mOneLineText' style={{ textTransform: "capitalize", fontSize: "20px" }}>{getChatTitle(JSON.parse(chatData.users))}</h6>

          <h6 
            className='mOneLineText font-light' 
            style={{ 
              fontSize: "14px", 
            }}>
            {topMessage}
          </h6>

          <h6 className='text-muted text-end' style={{ textTransform: "capitalize", fontSize: "12px", marginTop: "30px" }}>{formatDate(chatData.lastUpdated)}</h6>
          
        </div>
        :
        getInlineLoader('small')
      }
    </div>
  )

}
